import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { api, type PackagesListParams } from '@/lib/api-client'

/** Paginated/filtered package-redemption list (rows or patients call-list view). */
export function usePackages(params?: PackagesListParams) {
  return useQuery({
    queryKey: ['packages', params],
    queryFn: () => api.packages.list(params),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  })
}
